<template>
  <div class="app">
    <NuxtLoadingIndicator color="#E43233" :height="4" />
    <Title>{{ metadata.title }}</Title>
    <Meta name="description" :content="metadata.description" />
    <Meta name="keywords" :content="metadata.keywords" />
    <Meta property="og:title" :content="metadata.title" />
    <Meta property="og:description" :content="metadata.description" />
    <Meta property="og:image" :content="metadata.ogImage" />
    <Meta name="twitter:card" content="summary_large_image" />
    <Meta name="twitter:title" :content="metadata.title" />
    <Meta name="twitter:description" :content="metadata.description" />
    <Meta name="twitter:image" :content="metadata.ogImage" />
    <Link rel="icon" type="image/*" :href="metadata.favicon" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <!-- <VueQueryDevtools /> -->
  </div>
</template>

<script setup>
  import AOS from "aos";
  import "@/assets/fonts/fontawesome/css/solid.css";
  import "@/assets/fonts/fontawesome/css/fontawesome.css";
  import "aos/dist/aos.css";

  const { getCurrentPageSettings } = useWebsiteContent();
  const { data: currentPageSettings, suspense: currentPageSettingsSuspense } = getCurrentPageSettings();
  await currentPageSettingsSuspense();

  const metadata = computed(() => ({
    title: currentPageSettings.value.meta.title,
    description: currentPageSettings.value.meta.description,
    keywords: currentPageSettings.value.meta.keywords,
    ogImage: currentPageSettings.value.meta.ogImage,
    favicon: currentPageSettings.value.meta.favicon,
  }));

  onMounted(() => {
    AOS.init({
      once: true,
    });
  });
</script>

<style lang="scss">
  .app {
    overflow: hidden;
  }
</style>
